//DefaultTable

import * as React from 'react';
import { useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import { Button } from 'reactstrap';
import { alpha, styled } from '@mui/material/styles';
import { useIntl } from 'react-intl';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import InventoryIcon from '@mui/icons-material/Inventory';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import EventIcon from '@mui/icons-material/Event';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import AppsRoundedIcon from '@mui/icons-material/AppsRounded';
import ScaleIcon from '@mui/icons-material/Scale';

const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
    [`& .${gridClasses.row}.even`]: {
        backgroundColor: theme.palette.grey[200],
        '&:hover, &.Mui-hovered': {
            backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
        '&.Mui-selected': {
            backgroundColor: alpha(
                theme.palette.primary.main,
                ODD_OPACITY + theme.palette.action.selectedOpacity,
            ),
            '&:hover, &.Mui-hovered': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    ODD_OPACITY +
                    theme.palette.action.selectedOpacity +
                    theme.palette.action.hoverOpacity,
                ),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: alpha(
                        theme.palette.primary.main,
                        ODD_OPACITY + theme.palette.action.selectedOpacity,
                    ),
                },
            },
        },
    },
}));



const keyField = 'semana_Id';

export default function SemanasAdmin_Table(props) {
    const [pageSize, setPageSize] = React.useState(10);
    const [rows, setRows] = React.useState(props.data);
    const [sortModel, setSortModel] = React.useState([
        {
            field: keyField,
            sort: 'desc',
        },
    ]);
    const intl = useIntl();
    const navigate = useNavigate();
    const columns = [
        {
            field: keyField,
            headerName: 'ID',
            width: 90,
            type: 'number',
            hide: true
        },
        {
            field: 'nombre',
            headerName: intl.formatMessage({ id: 'Nombre' }),
            editable: false,
            flex: 0.5,
            hide: true
        },
        {
            field: 'year',
            headerName: intl.formatMessage({ id: 'Year' }),
            editable: false,
            flex: 0.5,
        },
        {
            field: 'week',
            headerName: intl.formatMessage({ id: 'Week' }),
            editable: false,
            flex: 0.5,
        },
        {
            field: 'proveedoresCerradosCount',
            headerName: intl.formatMessage({ id: 'Proveedores cerrados' }),
            editable: false,
            flex: 0.5,
            renderCell: (params) => {
                return(
                    <Tooltip arrow placement="top" title={params.row["proveedoresCerrados"]}>
                        <div>{params.row["proveedoresCerradosCount"]}</div>
                    </Tooltip>
                )
            }
        },
        {
            field: 'resumenDeCargas',
            headerName: '',
            sortable: false,
            editable: false,
            filterable: false,
            align: 'center',
            width: 300,
            renderCell: (params) => {
                return (
                    <div>
                        <Tooltip arrow placement="top" title={intl.formatMessage({ id: 'Archivos' })}>
                            <IconButton className="SoftOrangeButton GridButton" onClick={() => {
                                navigate('/Semanas/' + params.row[keyField] + '/PaletasBodega');
                            }}>
                                <DriveFolderUploadIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip arrow placement="top" title={intl.formatMessage({ id: 'Eventos' })}>
                            <IconButton className="DarkBlueButton GridButton" onClick={() => {
                                navigate('/Semanas/' + params.row[keyField] + '/EventosSemanales');
                            }}>
                                <EventIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip arrow placement="top" title={intl.formatMessage({ id: 'Vapores Semanales' })}>
                            <IconButton className="BurntSiennaButton GridButton" onClick={() => {
                                navigate('/Semanas/' + params.row[keyField] + '/VaporesSemanales');
                            }}>
                                <DirectionsBoatIcon /> 
                            </IconButton>
                        </Tooltip>
                        <Tooltip arrow placement="top" title={intl.formatMessage({ id: 'Resumen de cargas' })}>
                            <IconButton className="DarkTealButton GridButton" onClick={() => {
                                navigate('/Semanas/' + params.row[keyField] + '/ResumenDeCargas');
                            }}>
                                <InventoryIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip arrow placement="top" title={intl.formatMessage({ id: "ReporteDePesos" })}>
                            <IconButton className="BurntSiennaButton GridButton" onClick={() => {
                                navigate('/Semanas/' + params.row[keyField] + '/ReportePesosAdmin');
                            }}>
                                <ScaleIcon />
                            </IconButton>
                        </Tooltip>
                        {/*<Tooltip arrow placement="top" title={intl.formatMessage({ id: "VariantesAdminReporte" })}>*/}
                        {/*    <IconButton className="DarkBlueButton GridButton" onClick={() => {*/}
                        {/*        navigate('/Semanas/' + params.row[keyField] + '/VariantesAdminReporte');*/}
                        {/*    }}>*/}
                        {/*        <AppsRoundedIcon />*/}
                        {/*    </IconButton>*/}
                        {/*</Tooltip>*/}
                    </div>

                )
            },
        },

    ];
    const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({
        semana_Id: false,
        nombre: false,
    });
    return (
        <div>
            <Toolbar>
                <div className="row" style={{ width: '100%' }}>
                    <div className="col">
                        
                    </div>
                </div>
            </Toolbar>
            <Box sx={{
                height: 600, width: 1000,
            }}>

                <StripedDataGrid
                    rows={rows}
                    columns={columns}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[10, 20]}
                    pagination
                    disableRowSelectionOnClick
                    getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                    }
                    getRowId={(row) => row[keyField]}
                    sortModel={sortModel}
                    onSortModelChange={(newSortModel) => setSortModel(newSortModel)}

                    componentsProps={{
                        pagination: {
                            labelRowsPerPage: intl.formatMessage({ id: 'Resultados por pagina' }),
                            labelDisplayedRows: ({ from, to, count }) => `${from} - ${to} ${intl.formatMessage({ id: 'de' })} ${count}`,
                        }
                    }}

                    columnVisibilityModel={columnVisibilityModel}
                    onColumnVisibilityModelChange={(newModel) =>
                        setColumnVisibilityModel(newModel)
                    }
                />
            </Box>
        </div>
    );
}
